// B-1026 · EL AVISO VISIBLE DE LO QUE SE HA QUEDADO EN ESTE DISPOSITIVO SIN MANDAR («1 envío pendiente: se mandará
// solo»). Va montado una vez para toda la app (App.jsx), por encima de las rutas: se ve en la ficha, en la agenda y en
// el modo doctor, y no se pierde al cambiar de pantalla. Pulsándolo se ve qué es cada uno y qué se puede hacer.
// Lo que se guardó con OTRA cuenta o en OTRA clínica solo se cuenta: ni se enseña de qué paciente es ni se manda.
// t545 · Lo que ya no se va a poder mandar nunca (un 404 o un 403) sale UNA vez, con su motivo y sin «Reintentar»; las
// medidas de un periodontograma que ya no existe se pueden copiar o guardar en un estudio nuevo del mismo paciente.
import { useEffect, useState } from 'react'
import { cola, arrancarCola, rescatarMedidas } from '../services/colaEnvios'
import { TEXTOS_COLA } from '../utils/textosColaEnvios'
import { confirmar } from '../context/DialogosContext'
import { useToast } from '../context/ToastContext'
import { t as i18nT, tx, marca, tDato } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

const TIPO = { nota_voz: marca('components.AvisoEnviosPendientes.nota_de_voz', 'Nota de voz'), perio_dictado: marca('components.AvisoEnviosPendientes.dictado_del_periodontograma', 'Dictado del periodontograma'), perio_datos: marca('components.AvisoEnviosPendientes.medidas_del_periodontograma', 'Medidas del periodontograma'), chat_portal: marca('components.AvisoEnviosPendientes.archivo_por_el_portal', 'Archivo por el portal') }
const hora = (ms) => { try { return new Date(ms).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) } catch (_) { return '' } }

// t545 · Copiar al portapapeles; si el navegador no deja, devuelve false (y el texto se enseña para copiarlo a mano).
async function copiarTexto(texto) {
  try { if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(texto); return true } } catch (_) { /* sigue */ }
  try {
    const t = document.createElement('textarea')
    t.value = texto; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'
    document.body.appendChild(t); t.select()
    const ok = document.execCommand && document.execCommand('copy')
    t.remove()
    return !!ok
  } catch (_) { return false }
}

export default function AvisoEnviosPendientes() {
  const toast = useToast()
  const [r, setR] = useState(null)
  const [abierto, setAbierto] = useState(false)
  const [ocupado, setOcupado] = useState(null)     // t545 · el envío que se está guardando en un estudio nuevo
  const [aMano, setAMano] = useState(null)         // t545 · { id, texto } cuando el navegador no deja copiar
  useEffect(() => { arrancarCola(); return cola.suscribir(setR) }, [])
  const linea = TEXTOS_COLA.resumen(r)
  if (!linea) return null
  const hayProblema = !!(r.conflictos || r.fallidos)

  const copiarMedidas = async (e) => {
    const m = cola.medidasDe(e.id)
    if (!m) return
    const texto = TEXTOS_COLA.textoMedidas(m.datos, { etiqueta: e.etiqueta, creado: hora(e.creado_ms) })
    if (await copiarTexto(texto)) { setAMano(null); toast.success(TEXTOS_COLA.copiadas) }
    else { setAMano({ id: e.id, texto }); toast.info(TEXTOS_COLA.noCopiadas) }
  }
  const aEstudioNuevo = async (e) => {
    if (ocupado) return
    setOcupado(e.id)
    try {
      const res = await rescatarMedidas(e.id)
      if (res.ok && !res.reintentado) toast.success(TEXTOS_COLA.rescatado(res), 9000)
      else if (res.ok) toast.info(i18nT('components.AvisoEnviosPendientes.este_periodontograma_vuelve_a_existir', 'Este periodontograma vuelve a existir: las medidas se le están mandando.'))
      else toast.error(res.error)
    } finally { setOcupado(null) }
  }

  const descargar = (id) => {
    const a = cola.audioDe(id)
    if (!a || !a.blob) return
    const url = URL.createObjectURL(a.blob)
    const el = document.createElement('a')
    el.href = url; el.download = a.nombre || 'audio.webm'
    document.body.appendChild(el); el.click(); el.remove()
    setTimeout(() => URL.revokeObjectURL(url), 10000)
  }
  const descartar = async (e) => {
    const ok = await confirmar({
      titulo: i18nT('components.AvisoEnviosPendientes.descartar_este_envio', 'Descartar este envío'),
      mensaje: i18nT('components.AvisoEnviosPendientes.se_borrara_de_este_dispositivo', 'Se borrará de este dispositivo y no se mandará. {{x}}', { x: e.tieneAudio ? i18nT('components.AvisoEnviosPendientes.si_lo_necesitas_descarga_antes', 'Si lo necesitas, descarga antes el audio.')
        : e.definitivo && e.tieneMedidas ? i18nT('components.AvisoEnviosPendientes.si_las_necesitas_copia_antes', 'Si las necesitas, copia antes las medidas o guárdalas en un estudio nuevo.') : '' }),
      tipo: 'danger', textoConfirmar: i18nT('components.AvisoEnviosPendientes.descartar', 'Descartar'),
    })
    if (ok) await cola.descartar(e.id)
  }
  const boton = { padding: '5px 10px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text-primary)', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' }

  return (
    <div data-aviso-envios style={{ position: 'fixed', left: 16, bottom: 'calc(16px + var(--sa-abajo))', zIndex: 99980, maxWidth: 'min(460px, calc(100vw / var(--z, 1) - 32px))' }}>
      {abierto && (
        <div style={{ marginBottom: 8, padding: 12, borderRadius: 12, background: 'var(--surface)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-lg, 0 10px 30px rgba(0,0,0,0.2))', maxHeight: 'calc(60vh / var(--z, 1))', overflowY: 'auto', color: 'var(--text-primary)' }}>
          {(r.mias || []).map((e) => (
            <div key={e.id} data-envio={e.estado} style={{ padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
              <div style={{ fontWeight: 700, fontSize: 13.5 }}>{tDato(TIPO[e.tipo]) || i18nT('components.AvisoEnviosPendientes.envio', 'Envío')}{e.etiqueta ? ' · ' + e.etiqueta : ''}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{tx('components.AvisoEnviosPendientes.guardado_el', 'Guardado el {{hora}}', { hora: hora(e.creado_ms) })}</div>
              <div style={{ fontSize: 12.5, marginTop: 4, lineHeight: 1.45 }}>{TEXTOS_COLA.estado(e)}</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                {e.estado === 'conflicto' && <button type="button" style={boton} onClick={() => cola.forzar(e.id)}>{i18nT('components.AvisoEnviosPendientes.mandar_las_mias_igualmente', 'Mandar las mías igualmente')}</button>}
                {((e.estado === 'fallido' && !e.definitivo) || e.estado === 'pendiente') && <button type="button" style={boton} onClick={() => cola.reintentar(e.id)}>{e.estado === 'fallido' ? i18nT('components.AvisoEnviosPendientes.reintentar', 'Reintentar') : i18nT('components.AvisoEnviosPendientes.mandar_ahora', 'Mandar ahora')}</button>}
                {e.definitivo && e.tipo === 'perio_datos' && e.tieneMedidas && e.status !== 403 && e.motivo !== 'sin_acceso' && e.motivo !== 'permiso' && (
                  <button type="button" data-rescatar-perio="" style={boton} disabled={!!ocupado} onClick={() => aEstudioNuevo(e)}>
                    {ocupado === e.id ? i18nT('components.AvisoEnviosPendientes.guardando', 'Guardando…') : i18nT('components.AvisoEnviosPendientes.guardarlas_en_un_estudio_nuevo', 'Guardarlas en un estudio nuevo del mismo paciente')}
                  </button>
                )}
                {e.definitivo && e.tieneMedidas && <button type="button" data-copiar-medidas="" style={boton} onClick={() => copiarMedidas(e)}>{i18nT('components.AvisoEnviosPendientes.copiar_las_medidas', 'Copiar las medidas')}</button>}
                {e.tieneAudio && <button type="button" style={boton} onClick={() => descargar(e.id)}>{i18nT('components.AvisoEnviosPendientes.descargar_el_audio', 'Descargar el audio')}</button>}
                {e.estado !== 'enviando' && <button type="button" style={{ ...boton, color: 'var(--danger)' }} onClick={() => descartar(e)}>{i18nT('components.AvisoEnviosPendientes.descartar', 'Descartar')}</button>}
              </div>
              {aMano && aMano.id === e.id && (
                <textarea readOnly value={aMano.texto} rows={6} onFocus={(ev) => ev.target.select()}
                  style={{ width: '100%', marginTop: 6, fontSize: 12, fontFamily: 'inherit', border: '1px solid var(--border)', borderRadius: 8, background: 'var(--surface-2)', color: 'var(--text-primary)', padding: 6, boxSizing: 'border-box' }} />
              )}
            </div>
          ))}
          {r.deOtraSesion > 0 && <div style={{ fontSize: 12.5, marginTop: 8, lineHeight: 1.45, color: 'var(--text-secondary)' }}>{TEXTOS_COLA.otraSesion}</div>}
        </div>
      )}
      <button type="button" onClick={() => setAbierto((v) => !v)} aria-expanded={abierto}
        style={{ display: 'block', textAlign: 'left', padding: '8px 14px', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 700, lineHeight: 1.35,
          background: hayProblema ? 'var(--warning-bg, #fff4e5)' : 'var(--surface)', color: 'var(--text-primary)',
          border: '1px solid ' + (hayProblema ? 'var(--warning, #f59e0b)' : 'var(--primary)'), boxShadow: 'var(--shadow-md, 0 4px 14px rgba(0,0,0,0.15))' }}>
        {linea}
      </button>
    </div>
  )
}
